module.exports = __webpack_public_path__ + "img/title.230e35f6.png";